import React, { useEffect } from "react";
import Dropdown from "../form/dropDown";
import { cn } from "../../lib/utils";
import Input from "../form/Input";
import FileUploader from "./FIleUploader";
import { handleUploadFileUtils } from "../../api/fetchers";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { RadioGroup, RadioGroupItem } from "../ui/Radio";
import { useDispatch, useSelector } from "react-redux";
import QuestionHelpIcon from "../QuestionHelpIcon";
import { Danger } from "iconsax-reactjs";
import currencyPairCheck from "../../utilities/currencyPairCheck";
import { CRYPTO_NETWORKS } from "../../constants/global";

const paymentAgreementList = [
    { label: "Contract agreement", value: "contractAgreement" },
    { label: "SWIFT reference", value: "swiftReference" },
];

export const tokenType = [
    { value: "SWIFT", label: "SWIFT MT103 (Telex)" },
    { value: "UETR", label: "UETR" },
];

const PaymentFinance = ({
    network,
    setNetwork,
    contractAgreement,
    setContractAgreement,
    reason,
    setReason,
    paymentAgreement,
    setPaymentAgreement,
    uniqueWallet,
    setUniqueWallet,
    walletTouched,
    setWalletTouched,
    isWalletInvalid,
    swiftRefTouched,
    setSwiftRefTouched,
    isUetrInvalid,
    duration,
    setDuration,
    interest,
    setInterest,
    swiftRef,
    setSwiftRef,
    selectedToken,
    setSelectedToken,
    setPaymentAgreementDoc,
    paymentAgreementDoc,
  bankName,
  setBankName,
  contactPerson,
  setContactPerson,
  contactEmail,
  setContactEmail,
  payoutDestinationType,
  setPayoutDestinationType,
}) => {
    const { currency } = useSelector((state) => state);
    const dispatch = useDispatch();

    const { mutateAsync: uploadDocumentFunc, isLoading: uploadingDocsLoading } = useMutation({
        mutationFn: ({ selectedFile, name }) => {
            return handleUploadFileUtils({ selectedFile, name });
        },
        onError: (error) => {
            console.log({ error });
        },
    });

    useEffect(() => {
        if (currency !== "USDC" && currency !== "USDT") {
            dispatch({ type: "CURRENCY", payload: "USDC" });
        }
    }, [currency, dispatch]);

  const getDestinationLabel = (capitalize = false) => {
    const isCrypto = currencyPairCheck(currency, { returnType: "full" })?.isCrypto;
    const text = isCrypto ? "wallet address" : "account";
    if (capitalize) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    }
    return text;
  };

    return (
        <div className="space-y-6">
            <div>
                <label className={cn(`text-sm text-gray-70 font-normal mb-1`)}>
                    Purpose of funds
                </label>
                <textarea
                    className="rounded-lg placeholder:text-[15px] placeholder:text-sm placeholder:text-[#6F739B]/90 placeholder:font-normal resize-none h-[96px] w-full p-3 bg-[#EFF0FA]"
                    placeholder="Describe the reason for your request"
                    value={reason}
                    onChange={(evt) => setReason(evt.target.value)}
                />
                {reason && reason.length > 300 && (
                    <p className="text-xs text-[#C01515] font-normal mt-1">
                        Purpose of funds should not be more than 300 characters
                    </p>
                )}
            </div>

            <div className="flex items-center w-full gap-4">
                <div className="flex flex-col w-1/2">
                    <label className={cn(`text-sm text-gray-70 font-normal mb-1`)}>Duration</label>
                    <div className="h-[56px] !bg-[#EFF0FA] rounded-lg text-main-dark !px-4 placeholder:font-light placeholder:text-sm flex items-center justify-between placeholder:text-main-grey">
                        <input
                            type="number"
                            className="w-full h-full bg-transparent border-none outline-none text-main-dark"
                            value={duration}
                            placeholder="3"
                            onChange={(evt) => setDuration(evt.target.value)}
                        />
                        <p className="text-xs text-[#4F5372] text-nowrap">working days</p>
                    </div>
                    {duration && Number(duration) > 3 && (
                        <p className="text-xs text-[#C01515] font-normal mt-1">
                            The maximum duration is 72 working hours{" "}
                        </p>
                    )}
                </div>
                <div className="flex flex-col w-1/2">
                    <label className={cn(`text-sm text-gray-70 font-normal mb-1`)}>
                        Preferred interest
                    </label>
                    <div className="h-[56px] !bg-[#EFF0FA] rounded-lg text-main-dark !px-4 placeholder:font-light placeholder:text-sm flex items-center justify-between placeholder:text-main-grey">
                        <input
                            type="number"
                            className="w-full h-full bg-transparent border-none outline-none text-main-dark"
                            value={interest}
                            onChange={(evt) => setInterest(evt.target.value)}
                            placeholder="2.00"
                        />
                        <p className="text-xs text-[#4F5372] text-nowrap">% daily</p>
                    </div>
                </div>
            </div>

            <div className="!mb-[20px]">
                <Dropdown
                    value={paymentAgreement}
                    options={paymentAgreementList.map((option) => ({
                        label: option.label,
                        value: option.value,
                    }))}
                    onChange={(value) => setPaymentAgreement(value)}
                    label="Payment reference"
                    labelClassName="mb-1 text-sm text-gray-70 font-normal"
                    inputBg="#EFF0FA"
                    placeholder="Payment reference"
                />
                <div>
                    {paymentAgreement === paymentAgreementList[0].value ? (
                        <div>
                            <FileUploader
                                forFinance={true}
                                showSample={true}
                                details={
                                    <span>
                                        Agreement to carry out this contract with your contract
                                        employer
                                    </span>
                                }
                                isLoading={uploadingDocsLoading}
                                file={contractAgreement}
                                noModal
                                onChange={async (selectedFile, name) => {
                                    try {
                                        const response = await uploadDocumentFunc({
                                            selectedFile,
                                            name,
                                        });
                                        if (response?.statusCode !== 400) {
                                            const file = {
                                                size: selectedFile?.size,
                                                name,
                                                url: response?.link,
                                            };
                                            setContractAgreement(file);
                                        } else {
                                            toast.error(
                                                response?.message || "Error uploading file"
                                            );
                                        }
                                    } catch (error) {
                                        console.log({ error }, "error");
                                    }
                                }}
                            />
                        </div>
                    ) : null}

                    {paymentAgreement === paymentAgreementList[1].value && (
                        <RadioGroup
                            className="flex items-center justify-start gap-4 mt-3"
                            value={selectedToken}
                            onValueChange={(value) => setSelectedToken(value)}
                        >
                            {tokenType.map((option) => (
                                <div className="flex items-center gap-1" key={option.value}>
                                    <RadioGroupItem value={option.value} id={option.value} />
                                    <label htmlFor={option.value} className="text-sm text-gray-70">
                                        {option.label}
                                    </label>
                                </div>
                            ))}
                        </RadioGroup>
                    )}

            {paymentAgreement === "swiftReference" &&
              (selectedToken === "SWIFT" || selectedToken === "UETR") && (
              <div className="bg-[#FBFCFE] rounded-xl p-4 mt-4 space-y-4">
                {selectedToken === "UETR" && (
                  <div>
                    <label className="text-sm text-gray-70 font-normal mb-1 block">
                      UETR
                    </label>
                    <Input
                      inputClassName="!bg-[#EFF0FA] shadow-none"
                      className="!mt-0"
                      type="text"
                      name="swift"
                      value={swiftRef}
                      onChange={(value) => {
                        setSwiftRef(value);
                        if (!swiftRefTouched) setSwiftRefTouched(true);
                      }}
                      placeholder="e.g. 550e8400-e29b-41d4-a716-446655440000"
                    />
                    {isUetrInvalid && (
                      <p className="text-xs text-[#C01515] font-normal mt-1">
                        Please enter a valid UUIDv4 UETR (36 characters).
                      </p>
                    )}
                  </div>
                )}
                {selectedToken === "SWIFT" && (
                  <div>
                    <FileUploader
                      forFinance={true}
                      showSample={true}
                      isLoading={uploadingDocsLoading}
                      file={paymentAgreementDoc}
                      noModal
                      uploadText="Upload SWIFT document"
                      onChange={async (selectedFile, name) => {
                        try {
                          const response = await uploadDocumentFunc({
                            selectedFile,
                            name,
                          });
                          console.log({ response });
                          if (response?.statusCode !== 400) {
                            const file = {
                              size: selectedFile?.size,
                              name,
                              url: response?.link,
                            };
                            setPaymentAgreementDoc(file);
                          } else {
                            toast.error(
                              response?.message || "Error uploading file"
                            );
                          }
                        } catch (error) {
                          console.log({ error }, "error");
                        }
                      }}
                    />
                  </div>
                )}
                  <div>
                    <label className="text-sm text-gray-70 font-normal mb-1 block">
                    Bank name
                  </label>
                  <Input
                    inputClassName="!bg-[#EFF0FA] shadow-none"
                    className="!mt-0"
                    type="text"
                    name="bankName"
                    value={bankName}
                    onChange={(value) => setBankName(value)}
                    placeholder="Enter bank name"
                  />
                </div>

                <div className="flex items-center w-full gap-4">
                  <div className="flex flex-col w-1/2">
                    <div className="flex items-center gap-1">
                      <label className="text-sm text-gray-70 font-normal">
                        Contact person
                      </label>
                      <QuestionHelpIcon details="Details of the bank's contact person for verification" />
                    </div>
                    <Input
                      inputClassName="!bg-[#EFF0FA] shadow-none"
                      className="!mt-0"
                      type="text"
                      name="contactPerson"
                      value={contactPerson}
                      onChange={(value) => setContactPerson(value)}
                      placeholder="Enter full name"
                    />
                  </div>
                  <div className="flex flex-col w-1/2">
                    <label className="text-sm text-gray-70 font-normal mb-1 block">
                      Contact email
                    </label>
                    <Input
                      inputClassName="!bg-[#EFF0FA] shadow-none"
                      className="!mt-0"
                      type="text"
                      name="contactEmail"
                      value={contactEmail}
                      onChange={(value) => setContactEmail(value)}
                      placeholder="Enter contact email"
                    />
                  </div>
                </div>
              </div>
                        )}
                </div>
            </div>

        <div className="space-y-4 !mt-[50px]">
          <div className="flex items-center gap-1 mb-1">
            <label className={cn(`text-sm text-gray-70 font-[450]`)}>
              Preferred payout destination
            </label>
            <QuestionHelpIcon details="Select where the funds should be disbursed" />
          </div>

          <RadioGroup
            className="flex items-center justify-start gap-4 mt-2"
            value={payoutDestinationType}
            onValueChange={(value) => setPayoutDestinationType(value)}
          >
            <div className="flex items-center gap-1">
              <RadioGroupItem value="CreditWallet" id="CreditWallet" />
              <label htmlFor="CreditWallet" className="text-sm text-gray-70 cursor-pointer">
                Credit wallet
              </label>
            </div>
            <div className="flex items-center gap-1">
              <RadioGroupItem value="ExternalAccount" id="ExternalAccount" />
              <label htmlFor="ExternalAccount" className="text-sm text-gray-70 cursor-pointer">
                External {getDestinationLabel()}
              </label>
            </div>
          </RadioGroup>



          {payoutDestinationType === "ExternalAccount" && (
            <div className="bg-[#FBFCFE] rounded-xl p-4 mt-4 space-y-4">
              <Dropdown
                value={network}
                options={CRYPTO_NETWORKS.map((option) => ({
                  label: option,
                  value: option,
                }))}
                onChange={(value) => setNetwork(value)}
                label="Network"
                labelClassName="mb-1 text-sm text-gray-70 font-normal"
                inputBg="#EFF0FA"
                placeholder="Select a network"
              />
              <div>
                <label className={cn(`text-sm text-gray-70 font-normal mb-1 block`)}>
                  {getDestinationLabel(true)}
                </label>
                <Input
                  inputClassName="!bg-[#EFF0FA] shadow-none"
                  className="!mt-0"
                  type="text"
                  name="uniqueWallet"
                  onChange={(value) => {
                    setUniqueWallet(value);
                    if (!walletTouched) setWalletTouched(true);
                  }}
                  value={uniqueWallet}
                  placeholder={`Enter unique ${getDestinationLabel()}`}
                />
                {isWalletInvalid && (
                  <p className="text-xs text-[#C01515] font-normal mt-1">
                    Please enter a valid Polygon/Base address (0x followed by 40 hexadecimal
                    characters).
                  </p>
                )}
              </div>


              <div className="bg-[#FFFCF5] rounded-lg p-3 flex items-start gap-2.5">
                <div className=" text-[#D97706] size-8 grid place-items-center bg-[#FFEFC6] rounded-full p-1.5">
                  <Danger variant="Bold" size="18" color="#D97706" />
                </div>
                <div className="flex flex-col">
                  <span className="text-sm font-semibold text-[#494E6E] leading-tight">
                    Double-check the {getDestinationLabel()} and network before submitting
                  </span>
                  <span className="text-sm text-[#494E6E] mt-0.5 leading-normal">
                    Incorrect details may result in permanent loss of funds
                  </span>
                </div>
              </div>
            </div>
          )}
            </div>
        </div>
    );
};

export default PaymentFinance;
